const MailCheck = require('mailcheck');

(function ($) {
    const suggestions = App.suggestions.middleName || [];

    const $form = $('form.signup-form');

    const $middleName = $form.find('#middle-name');
    const $middleNameField = $middleName.find('input');

    if ($middleName.length) {
        $middleName.autocomplete({
            minLength: 2,

            delay: 10,

            appendTo: $middleNameField,

            open: () => {
                $middleNameField.addClass('ui-autocomplete-open');
            },

            close: (event) => {
                $middleNameField.removeClass('ui-autocomplete-open');

                if (typeof event.currentTarget === 'undefined') {
                    $middleNameField.val('');
                }
            },

            source: (request, response) => {
                const results = $.ui.autocomplete.filter(suggestions, request.term);
                response(results.slice(0, 10));
            },
        });
    }

}(jQuery));

(function ($) {
    let zipCode;
    let houseNumber;
    let houseNumberSuffix;

    let request;
    let response;

    const $addressForm = $('.address-form');
    const $submitButton = $('.disable-on-error');
    const $loading = $addressForm.find('.loading');

    const $zipCodeField = $addressForm.find('#zip-code');
    const $houseNumberField = $addressForm.find('#house-number');
    const $streetField = $addressForm.find('#street');
    const $cityField = $addressForm.find('#city');

    const $houseNumberSuffix = $addressForm.find('.house-number-suffix');
    const $houseNumberSuffixField = $addressForm.find('#house-number-suffix');
    const $houseNumberWrapper = $addressForm.find('.housenr');

    const $addressKeyField = $addressForm.find('#address-key');
    const $clearAddressButton = $addressForm.find('#clear-address');
    const $undoClearAddressButton = $addressForm.find('#undo-clear');

    const zipCodeRegex = new RegExp('^[1-9][0-9]{3}\\s*(?!sa|sd|ss)[a-z]{2}$', 'i');
    const houseNumberRegex = new RegExp('^\\d{1,5}$');

    zipCode = $zipCodeField.val();
    houseNumber = $houseNumberField.val();
    houseNumberSuffix = $houseNumberSuffixField.val();

    $addressKeyField.on('change', () => {
        $submitButton.prop('disabled', $addressKeyField.val().length === 0);
    });

    $zipCodeField.on('keyup', () => {
        zipCode = $zipCodeField.val().toUpperCase();
        $zipCodeField.val(zipCode);
        const isValid = zipCodeRegex.test(zipCode);

        $zipCodeField.toggleClass('incorrect', !isValid);

        validateAddress();

        if (zipCode.length < 6) {
            $houseNumberField.val('');

            $streetField.val('');
            $cityField.val('');
            $houseNumberSuffixField.empty();

        }
    });

    $houseNumberField.on('keyup', () => {

        houseNumber = $houseNumberField.val();

        if (houseNumber.length > 0) {
            const isValid = houseNumberRegex.test(houseNumber);

            if (!isValid) {

                if ($('#input_numbers').length === 0) {
                    $houseNumberWrapper.append('<div id="input_numbers" class="text-sm text-input-error">Alleen cijfers!</div>');
                }

            } else {

                $houseNumberWrapper.find('#input_numbers').remove();
            }

            validateAddress();
        }
    });

    const validateAddress = _.debounce(() => {
        if (!(zipCode && houseNumber)) {
            return;
        }

        $loading.show();

        if (request) {
            request.abort();
        }

        request = $.ajax({
            type: 'get',

            url: '/check-address',

            data: {
                zip_code: zipCode,
                house_number: houseNumber
            },

            success: (data) => {
                clearHelpMessages([$zipCodeField, $houseNumberField, $houseNumberSuffixField]);

                if (data.length === 1) {
                    $streetField.val(data[0].street);
                    $cityField.val(data[0].city);

                    $houseNumberSuffix.addClass('is-disabled');

                    $houseNumberSuffixField.attr('disabled', true);
                    $houseNumberSuffixField.empty();

                    $addressKeyField.val(data[0].key).trigger('change');

                    return;
                }

                if (data.length > 1) {
                    response = data;

                    $houseNumberSuffixField.empty();
                    $addressKeyField.val('').trigger('change');
                    $houseNumberSuffixField.val('').trigger('change');

                    $houseNumberSuffixField.addClass('incorrect');

                    data.forEach(suffix => {
                        const suffixKey = suffix.house_number_suffix;
                        const suffixLabel = suffix.house_number_suffix || '-';

                        $houseNumberSuffixField.append(
                            '<option value="' + suffixKey + '">' + suffixLabel + '</option>'
                        );
                    });

                    if (houseNumberSuffix) {
                        $houseNumberSuffixField.val(houseNumberSuffix);

                        setAddressKey(houseNumberSuffix);
                    } else {
                        var _$locale = $('html').attr('lang').substr(0, 2);

                        if (_$locale === 'nl') {
                            $select = 'selecteer';
                        } else {
                            $select = 'select';
                        }

                        $houseNumberSuffixField.prepend('<option value="" selected>'+ $select +'</option>');
                    }

                    $houseNumberSuffixField.attr('disabled', false);
                    $houseNumberSuffixField.attr('tabindex', 3);

                    $houseNumberSuffix.removeClass('is-disabled');
                }
            },

            error: (xhr) => {
                if (xhr.status === 422) {
                    const data = JSON.parse(xhr.responseText);

                    Object.keys(data.errors).forEach(key => {
                        const errorMessage = data.errors[key][0];

                        displayErrorMessage(key, errorMessage);
                    });

                    clearFields(false);
                }
            },

            complete: () => {
                $loading.hide();
            }
        });
    }, 400);

    const displayErrorMessage = function (key, message) {
        const $field = $('[name=' + key + ']');

        clearHelpMessages([$field]);

        if ($field.length) {

            $field.parent().append('<div class="text-sm text-input-error">' + message + '</div>');
        }
    };

    const clearFields = function (withZip = true) {
        if (request) {
            request.abort();
        }

        if (withZip) {
            $zipCodeField.attr('readonly', false).val('');
            $houseNumberField.attr('readonly', false).val('');
            $houseNumberSuffixField.attr('disabled', true).val('');
        }

        $streetField.val('');
        $cityField.val('');

        $addressKeyField.val('').trigger('change');

        $zipCodeField.focus();
    };

    const setAddressKey = function (value) {
        $addressKeyField.val('');

        response.forEach(address => {
            if (address.house_number_suffix === value) {
                $cityField.val(address.city);
                $streetField.val(address.street);

                $addressKeyField.val(address.key).trigger('change');
            }
        });
    };

    $houseNumberSuffixField.on('change', () => {
        const value = $houseNumberSuffixField.val();

        houseNumberSuffix = value;

        setAddressKey(value);

        $houseNumberSuffix.removeClass('incorrect');

    });

    $clearAddressButton.on('click', () => {
        clearFields();
        $clearAddressButton.addClass('hidden');
        $undoClearAddressButton.removeClass('hidden');

        clearHelpMessages([$zipCodeField, $houseNumberField, $houseNumberSuffixField]);
    });

    $undoClearAddressButton.on('click', () => {
        $clearAddressButton.removeClass('hidden');
        $undoClearAddressButton.addClass('hidden');

        $submitButton.prop('disabled', false);
        $zipCodeField.attr('readonly', true);
        $houseNumberField.attr('readonly', true);
        $houseNumberSuffixField.attr('disabled', false);

        $('#address-key').val($('#address-key').data('key'));

    })

    const clearHelpMessages = function (fields) {
        fields.forEach(field => {
            field.parent().find('.text-input-error').remove();
        });
    };
}(jQuery));

(function ($) {
    const $form = $('form.signup-form');
    const $firstname = $form.find('#first-name');
    const $middlename = $form.find('#middle-name');
    const $lastname = $form.find('#last-name');
    const $replacefields = $form.find('.replace-chars');

    const $removechars = /[0-9\+\=\!\?\"\&\%\$\@\#\^\(\)\:\;\<\>\!\*\{\}\[\]\,\.\/\\\|\_]/g

    $replacefields.on('keyup', function () {
        let str = $(this).val();
        $(this).val(str.replace($removechars, ''));
    });


    $firstname.on('blur', function () {
        let str = $(this).val();
        str = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
            return letter.toUpperCase();
        });

        str = str.replace(/^\s?[\-]+\s?|\s?[\-]+\s?$/g,'');
        $(this).val(str);

        $('#ferror').remove();

        if ($locale === 'nl') {
            message = 'Voornaam moet minimaal 2 karakters zijn';
        } else {
            message = 'First name should be at least 2 characters.';
        }

        if ( str.length < 2 &&  !$firstname.hasClass('text-input-error'))  {
            $firstname.addClass('incorrect');
            $('.first_name').append('<div id="ferror" class="text-sm text-input-error">'+ message +'</div>');
        }
    });

    $middlename.on('blur', function () {
        let str = $(this).val();
        str = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
            return letter.toLowerCase();
        });
        str = str.replace(/^\s?[\-]+\s?|\s?[\-]+\s?$/g,'');
        $(this).val(str);
    });

    $lastname.on('blur', function () {
        let str = $(this).val();
        str = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
            return letter.toUpperCase();
        });
        str = str.replace(/^\s?[\-]+\s?|\s?[\-]+\s?$/g,'');
        $(this).val(str);

        $('#lerror').remove();

        if ($locale === 'nl') {
            message = 'Achternaam moet minimaal 2 karakters zijn';
        } else {
            message = 'Last name should be at least 2 characters.';
        }

        if ( str.length < 2 &&  !$lastname.hasClass('text-input-error') )  {
            $lastname.addClass('incorrect');
            $('.last_name').append('<div id="lerror" class="text-sm text-input-error">'+ message +'</div>');
        }

    });

}(jQuery));

(function ($) {
    const emailRegex = new RegExp('^([a-z0-9\_\-]+)(\.[a-z0-9\_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,6}$');

    const domains = 'hotmail.com gmail.com live.nl yahoo.com hotmail.nl msn.com home.nl hetnet.nl outlook.com planet.nl chello.nl ziggo.nl zonnet.nl upcmail.nl kpnmail.nl casema.nl kpnplanet.nl zeelandnet.nl quicknet.nl live.com xs4all.nl online.nl telfort.nl yahoo.co.uk icloud.com me.com solcon.nl freeler.nl kliksafe.nl versatel.nl tele2.nl yahoo.fr caiway.nl mail.ru tiscali.nl kabelfoon.nl hotmail.fr mail.com wxs.nl cs.com yahoo.nl gmx.net hotmail.de gmx.de web.de ymail.com yahoo.de telenet.be hccnet.nl yahoo.es abv.bg live.be windowslive.com filternet.nl googlemail.com knid.nl qq.com hotmail.co.uk interia.eu 12move.nl yahoo.it concepts.nl'.split(' ');
    const topLevelDomains = 'com net org nl nu be de'.split(' ');

    const $form = $('form.signup-form');
    const $emailPlaceholder = $form.find('#email-placeholder');

    const $email = $form.find('.email');
    const $emailField = $email.find('input');

    const $emailSuggestion = $form.find('#email-suggestion');
    const $emailExistsContainer = $form.find('#email-exists-container');

    const $emailSuggestions = $form.find('#email-suggestion');

    const $redirectToLogin = $emailExistsContainer.find('a');

    $emailField.on('blur', function () {
        const emailValue = $emailField.val();
        const $locale = $('html').attr('lang').substr(0, 2);

        $('#jerror').remove();

        if ($locale === 'nl') {
            message = 'E-mailadres is niet een geldig e-mailadres.';
        } else {
            message = 'E-mail addres is not an valid e-mail address';
        }
        if (!emailRegex.test(emailValue)) {
            $('#email').addClass('incorrect');
            $email.append('<div id="jerror" class="text-sm text-input-error">'+ message +'</div>');
            $emailField.removeClass('focus:outline-input-border').addClass('focus:outline-none');
        }
        $emailSuggestion.hide();
    });

    $emailField.on('keyup', _.debounce(() => {
        let str = $emailField.val();
        str = str.toLowerCase();
        $emailField.val(str);

        const emailValue = $emailField.val();

        $form.removeClass('email_exists');

        $emailPlaceholder.text(emailValue);
        $emailExistsContainer.hide();

        if (!emailRegex.test(emailValue)) {
            return;
        }

        $email.removeClass('incorrect');
        $emailField.addClass('focus:outline-input-border').removeClass('focus:outline-none');

        $.ajax({
            type: 'post',
            url: '/check-email',
            data: {
                email: emailValue
            },

            success: () => {
                MailCheck.run({
                    email: emailValue,
                    domains,
                    topLevelDomains,

                    suggested: (suggestion) => {
                        $emailSuggestion.find('.address').text(suggestion.address);
                        $emailSuggestion.find('.domain').text(suggestion.domain);

                        $emailSuggestion.data('suggestion', suggestion.full).show();
                    },

                    empty: () => {
                        $emailSuggestion.hide();
                    }
                });
            },

            error: (data) => {
                const statusCode = data.status;

                // Validation error
                if (statusCode === 422) {
                    $email.addClass('incorrect');
                }

                // E-mail in use
                if (statusCode === 423) {
                    $form.addClass('email_exists');

                    $emailExistsContainer.show();
                    $emailSuggestions.hide();
                    let source = $redirectToLogin.data('source')
                    if(source) {
                        $redirectToLogin.prop('href', window.App.appDomain + '/zwanger/login/?id=' + emailValue + '&source=' + source);
                    } else {
                        $redirectToLogin.prop('href', window.App.appDomain + '/zwanger/login/?id=' + emailValue);
                    }
                }
            }
        });
    }, 250));

    $emailSuggestion.on('click', 'a', () => {
        $emailField.val($emailSuggestion.data('suggestion'));

        $emailSuggestion.hide();
    });
}(jQuery));

(function ($) {

    const passwordAtLeastOneDigit = text => /[0-9]/.test(text);

    const passwordAtLeastOneUppercase = text => /[A-Z]/.test(text);

    const passwordAtLeastOneLowercase = text => /[a-z]/.test(text);

    const passwordAtLeastOneSpecialCharacter = text => /[~`!@#$%^&*+=\-\[\]\\';,/{}|":<>?]/g.test(text);

    const passwordAtLeastEightCharacters = text => text.length >= 8;

    const passwordHasTwelveCharacters = text => text.length >= 12;

    const passwordHasUniqueCharacters = text => {
        const total = uniqueCharacters(text).length;

        return text.length >= 8 && (total / text.length) > .75;
    };

    const uniqueCharacters = value => String.prototype.concat(...new Set(value));

    const determineScore = value => {
        let score = 0;

        $passwordForm.find('[data-lowercase], [data-uppercase], [data-digit], [data-special-character], [data-length]').removeClass('active');

        if (passwordAtLeastOneLowercase(value)) {
            $passwordForm.find('[data-lowercase]').addClass('active');

            score++;
        }

        if (passwordAtLeastOneUppercase(value)) {
            $passwordForm.find('[data-uppercase]').addClass('active');

            score++;
        }

        if (passwordAtLeastOneDigit(value)) {
            $passwordForm.find('[data-digit]').addClass('active');

            score++;
        }

        if (passwordAtLeastOneSpecialCharacter(value)) {
            $passwordForm.find('[data-special-character]').addClass('active');

            score++;
        }

        if (passwordAtLeastEightCharacters(value)) {
            $passwordForm.find('[data-length]').addClass('active');

            score++;
        }

        if (passwordHasTwelveCharacters(value)) {
            score++;
        }

        if (passwordHasUniqueCharacters(value)) {
            score++;
        }

        return score;
    };

    const calculateProgress = score => {
        return (score / 7) * 100;
    };

    const $passwordForm = $('form.password-form');

    const $password = $passwordForm.find('.password');
    const $passwordField = $password.find('input');

    const $confirmPassword = $passwordForm.find('.password-confirmation');
    const $confirmPasswordField = $confirmPassword.find('input');

    const $passwordStrengthIndicatorDropdown = $passwordForm.find('.password-strength-indicator-dropdown');
    const $passwordStrengthIndicator = $passwordForm.find('.password-strength-indicator');

    $passwordField.on('focus keyup', () => {
        const score = determineScore($passwordField.val());

        const $progress = $passwordStrengthIndicator.find('.progress');

        $progress.css({ width: calculateProgress(score) + '%' });

        $progress.toggleClass('valid', score >= 5);
        $passwordStrengthIndicatorDropdown.toggle(score < 5);
    });

    $confirmPasswordField.on('focus keyup', () => {
        const isEqual = $confirmPasswordField.val() === $passwordField.val();

        $confirmPasswordField.toggleClass('incorrect', !isEqual);
    });

    $(".fa-eye-slash").hide();

    const $togglePassword = $passwordForm.find('.toggle-password');

    $togglePassword.on('click', () => {
        const currentType = $passwordField.attr('type');

        if (currentType === 'password') {
            $passwordField.attr('type', 'text');
            $(".fa-eye").hide();
            $(".fa-eye-slash").show();
        } else {
            $passwordField.attr('type', 'password');
            $(".fa-eye").show();
            $(".fa-eye-slash").hide();
        }
    });

}(jQuery));

(function ($) {

    $('.wrap-input input').on('keydown change', function () {
        const $parent = $(this).parents('.form-input');
        $(this).removeClass('incorrect');
        $parent.find('.text-input-error').remove();
    });

}(jQuery));

(function ($) {

    $locale = $('html').attr('lang').substr(0, 2);
    if ($locale === 'nl') {
        $.extend($.validator.messages, {
            required: "Dit is een verplicht veld.",
            minlength: "Naam is niet juist",
            email: "Vul hier een geldig e-mailadres in.",
        });
    } else {
        $.extend($.validator.messages, {
            required: "This is an required field.",
            minlength: "Name is incorrect",
            email: "Please enter an valid email address.",
        });
    }

    $('form').not('[novalidate]').validate({

        errorElement: 'div',
        errorClass: 'text-sm text-input-error',
        errorParentClass: 'incorrect',

        highlight(element, errorClass, validClass) {
            $(element).addClass(this.settings.errorParentClass);
        },

        unhighlight(element, errorClass, validClass) {
            $(element).removeClass(this.settings.errorParentClass);
        }
    });
}(jQuery));

